import { render } from "./Moderation.vue?vue&type=template&id=429c9e48&scoped=true"
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"

import "./Moderation.vue?vue&type=style&index=0&id=429c9e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429c9e48"]])

export default __exports__